"use client";

import { useEffect } from "react";
import { FirstRunIntro, type FirstRunIntroProps } from "./FirstRunIntro";

/**
 * The intro as the entry screen of `/`: rendered in place of today's setup,
 * not laid over it, so there is no moment where the original page shows
 * first. The page is held still until the horizon starts to set.
 */
export function FirstRunIntroScreen(props: FirstRunIntroProps) {
  const { leaving, onShown } = props;

  // The real intro is on screen: its arm may be counted as exposed.
  useEffect(() => {
    onShown?.();
  }, [onShown]);

  useEffect(() => {
    if (leaving) return;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = overflow;
    };
  }, [leaving]);

  return <FirstRunIntro {...props} />;
}
